export default "__VITE_ASSET__cGTBYYcQ__"